





































































































































































































































import Vue from "vue";
import { Component } from "vue-property-decorator";
import { mapState, mapGetters } from "vuex";
import { ProjectType } from "@/models/project/project-type";
import Project from "@/models/project/project";
import Request from "@/models/checkRequest/request";
import ImportService from "@/services/importService";
import ListItem from "@/components/url/list-item.vue";
import ISetting from "@/interfaces/setting";
import * as _ from "lodash";
import { ADD_PROJECT } from "@/store/mutation-types";

@Component({
  computed: {
    ...mapState("settings", [
      "availableHttpMethods",
      "availableUserAgents",
      "userSettings",
    ]),
    ...mapGetters("subscriptions", ["hasActiveSubscription"]),
  },
  components: {
    ListItem,
  },
})
export default class ProjectNew extends Vue {
  // mapState + mapGetters
  hasActiveSubscription!: boolean;
  availableHttpMethods!: Array<string>;
  availableUserAgents!: Array<object>;
  userSettings!: Array<ISetting>;
  invalidUrls!: Array<Request>;

  loading = false;

  project: Project = new Project();
  importService: ImportService = new ImportService();
  step = 1;

  handleReady(result: Array<Request>) {
    if (result.length) {
      this.project.requests = result;
      this.invalidUrls = this.project.requests.filter((p) => !p.isValid);
      this.loading = true;
    }

    setTimeout(() => {
      this.nextStep();
      this.loading = false;
    }, 750);
  }

  setDefaultSettings() {
    //
    // Clone settings instead of making a reference
    this.project.settings = _.cloneDeep(this.userSettings);
  }
  //
  // Settings
  get localDefaultHttpMethod() {
    const setting = this.project.settings.find(
      (s) => s.key == "DefaultHttpMethod"
    );
    if (setting) {
      return setting.value.toString();
    }

    return "";
  }

  set localDefaultHttpMethod(newValue: string) {
    const setting = this.project.settings.find(
      (s) => s.key == "DefaultHttpMethod"
    );
    if (setting) {
      setting.value = newValue;
    }
  }

  get localUserAgent() {
    const setting = this.project.settings.find((s) => s.key == "UserAgent");
    if (setting) {
      return setting.value.toString();
    }

    return "";
  }

  set localUserAgent(newValue: string) {
    const setting = this.project.settings.find((s) => s.key == "UserAgent");
    if (setting) {
      setting.value = newValue;
    }
  }

  get localValidateSslCertificate(): boolean {
    const setting = this.project.settings.find(
      (s) => s.key == "ValidateSslCertificate"
    );
    if (setting) {
      return Boolean(setting.value);
    }

    return false;
  }

  set localValidateSslCertificate(newValue: boolean) {
    const setting = this.project.settings.find(
      (s) => s.key == "ValidateSslCertificate"
    );
    if (setting) {
      setting.value = newValue;
    }
  }

  get localFollowRedirects(): boolean {
    const setting = this.project.settings.find(
      (s) => s.key == "FollowRedirects"
    );
    if (setting) {
      return Boolean(setting.value);
    }

    return false;
  }

  set localFollowRedirects(newValue: boolean) {
    const setting = this.project.settings.find(
      (s) => s.key == "FollowRedirects"
    );
    if (setting) {
      setting.value = newValue;
    }
  }

  mounted() {
    this.setDefaultSettings();
  }

  setType(type: ProjectType) {
    this.project.type = type;
  }

  createProject() {
    this.$store.commit(`projects/${ADD_PROJECT}`, this.project);
    this.project = new Project();
    this.$router.push({ name: "Dashboard" });
  }

  previousStep() {
    this.step--;
  }

  nextStep() {
    this.step++;
  }
}
